module.exports = __webpack_public_path__ + "75f6dc33bc3a88cd2833a59d78d7d4fc.png";